import enabled from '../../../lib/enabled'

export default (form, baseName, isItem) => () => {
  const newValue = !enabled(form, baseName)
  form.setFieldValue(`${baseName}.enabled`, newValue)

  if (!isItem || !newValue) return

  const parentBaseName = baseName.split('.')[0]
  form.setFieldValue(`${parentBaseName}.enabled`, newValue)
}
